export const sliderLaraThemeConfig = {
  colorScheme: {
    light: {
      trackSize: "var(--spacing-8)",
      trackBackground: "{gray.200}",
      rangeBackground: "{primary.600}",
      handleContentWidth: "24px",
      handleContentHeight: "24px",
      handleContentBackground: "white",
      handleWidth: "25.5px",
      handleHeight: "25.5px",
    },
  },
  css: ({ dt }: any) => `
    .p-slider {
      border-radius: var(--radius-4);
    }
  `,
};
